import initialState from './state.js'

export default {
  RESET_CAMPANHAS_MODULE(state) {
    Object.keys(initialState).forEach((key) => {
      state[key] = initialState[key]
    })
  },
  smsCountsChanged(state, payload) {
    state.smsCountsChanged = payload
  },
  smsCostMessage(state, payload) {
    state.smsCostMessage = payload
  },
  SET_SEGMENTOS(state, payload) {
    state.segmentos = payload
  },
}
